import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.95827 7.92853H15.6249M5.4662 3V4.28586M13.9582 3V4.2857M16.4582 6.53569V14.7499C16.4582 15.9926 15.4633 16.9999 14.236 16.9999H5.34715C4.11986 16.9999 3.12494 15.9926 3.12494 14.7499V6.53569C3.12494 5.29306 4.11986 4.2857 5.34715 4.2857H14.236C15.4633 4.2857 16.4582 5.29306 16.4582 6.53569Z",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }